<template>
  <div
    class="our-mission-wrapper"
    data-test-id="component-about-our-mission"
  >
    <div class="lg:hidden">
      <div class="group-pictures-cover bg-infra-violette bg-center bg-no-repeat bg-cover" />
    </div>
    <div class="container our-mission-container mt-large mb-xl">
      <div class="flex flex-wrap  -mx-tiny">
        <div class="flex w-full px-standart">
          <h2 class="h2 uppercase text-secondary">
            {{ $messages('about.our_mission.hey_there') }}
          </h2>
        </div>
      </div>
      <div class="flex flex-wrap  -mx-tiny">
        <div class="flex w-full lg:w-1/2 px-standart">
          <h3 class="h3">
            {{ $messages('about.our_mission.we_are_majority') }}
          </h3>
        </div>
      </div>
      <div class="flex flex-wrap  -mx-tiny mt-large">
        <div class="hidden lg:block w-2/3 px-standart">
          <img src="https://majority.imgix.net/web-assets/about-us/group-picture-1-3x.jpg" alt="Group/company pictures">
        </div>
        <div class="block w-full lg:w-1/3 px-standart ">
          <div class="group-pictures flex flex-col md:flex-row lg:flex-col h-full justify-between">
            <div class="picture-2">
              <img src="https://majority.imgix.net/web-assets/about-us/group-picture-2-3x.jpg" alt="Group/company pictures">
            </div>
            <div class="picture-2">
              <img src="https://majority.imgix.net/web-assets/about-us/group-picture-3-3x.jpg" alt="Group/company pictures">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="postcss" scoped>
.group-pictures-cover {
  min-height: 57vh;
  background-image: url('https://majority.imgix.net/web-assets/about-us/group-picture-1-3x.jpg');
}
</style>
